import { useCallback, useMemo } from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';

import { DropdownMenuPosition } from 'ui-components/components/INTERNAL/dropdown/dropdown-menu-position';
import { LinkDatePicker } from 'ui-components/components/link-date-picker';

import { DateService } from '../../services/date-service';
import Global from '../../store/global-selectors';
import { useFulfillmentPlannerContext } from '../context';
import style from './style.module.less';
import { getShipDateFromEntity } from '../context/hooks';

/**
 * @typedef {import('ui-components/components/dropdown/dropdown-types.d.ts').DropdownMenuPositions} DropdownMenuPositions
 */

/**
 * @typedef {import('../../prop-types/intl-types.d.ts').MessageDescriptor} MessageDescriptor
 */

/**
 * @param {object} props
 * @param {string} props.className
 * @param {DropdownMenuPositions} props.calendarPosition
 * @param {string} props.linkButtonClassName
 * @param {MessageDescriptor} props.displayMessage
 * @param {string} props.dropdownIconClassName
 * @returns {JSX.Element}
 */
const ShipDate = ({
  className,
  calendarPosition = DropdownMenuPosition.TopRight,
  linkButtonClassName,
  displayMessage,
  dropdownIconClassName,
}) => {
  const dateFormat = useSelector(Global.selectUserUserDateFormat);
  const { shipDate, onShipDateChange } = useFulfillmentPlannerContext();
  const memoizedShipDate = useMemo(() => {
    return getShipDateFromEntity(shipDate);
  }, [shipDate]);

  const _onChange = useCallback(
    (newShipDate) => {
      onShipDateChange(newShipDate, dateFormat);
    },
    [onShipDateChange, dateFormat],
  );

  return (
    <LinkDatePicker
      allowPastDates={false}
      calendarPosition={calendarPosition}
      className={className}
      dateFormat={dateFormat}
      displayMessageDescriptor={displayMessage}
      dropdownIconClassName={dropdownIconClassName}
      linkButtonClassName={classnames(style['date-picker-link-button'], linkButtonClassName)}
      onChange={_onChange}
      value={DateService.getFormattedDate(memoizedShipDate, dateFormat)}
    />
  );
};

export default ShipDate;
